import { schema } from 'normalizr';

import { processUserHideField } from '../strategies/userHideField';

export const userHideFieldSchema: schema.Entity = new schema.Entity(
  'userHideFields',
  {},
  { processStrategy: processUserHideField }
);
